import { FlowType } from "src/app/models/proofreading.model";
import { IFlowsDefinition } from "../definitions";



export const FlowConfig: IFlowsDefinition = {
  [FlowType.HD]: {
    prefix: 'HD',
    path: {
      parent: '3. Hd',
      final: '_DOCS_DEFINITIFS',
    },
    style: {
      color: '#EAA82B',
      bg_color: '#EAA82B',
    }
  },
  [FlowType.CREA]: {
    prefix: 'Crea',
    path: {
      parent: '5. Crea',
      final: '_DOCS_DEFINITIFS',
    },
    style: {
      color: '#DE5F4D',
      bg_color: '#DE5F4D',
    }
  },
  [FlowType.EXE]: {
    prefix: 'Relecture',
    path: {
      parent: '2. Exe',
      final: '_DOCS_DEFINITIFS',
    },
    style: {
      color: '#709A9D',
      bg_color: '#709A9D',
    }
  },
  [FlowType.REPRO]: {
    prefix: 'Version',
    path: {
      parent: '4. Repro',
      final: '_REPRO_VALIDES',
    },
    style: {
      color: '#323232',
      bg_color: '#323232',
    }
  },
  [FlowType.BAT]: {
    prefix: 'Version',
    path: {
      parent: '9. Depot_BAT',
      final: '',
    },
    style: {
      color: '#7087aa',
      bg_color: '#7087aa',
    }
  }

};


export function getFlowConfig(flow: FlowType | undefined) {
  if(flow === undefined) {
    return FlowConfig[FlowType.EXE];
  }
  return FlowConfig[flow] ?? FlowConfig[FlowType.EXE]; 
}
